import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../../Panel';
import styles from './FeatureStatistics.module.scss';
import { FEATURE_TYPES } from '../../../../lib/constants';
import WaypointStats from './WaypointStats';
import AreaStats from './AreaStats';
import LineStats from './LineStats';
import TrackStats from './TrackStats';
export default function FeatureStatistics(props) {
  let StatComponent = React.Fragment;

  switch (props.feature.properties.ghType) {
    case FEATURE_TYPES.Point:
      StatComponent = WaypointStats;
      break;
    case FEATURE_TYPES.Polygon:
      StatComponent = AreaStats;
      break;
    case FEATURE_TYPES.Polyline:
      StatComponent = LineStats;
      break;
    case FEATURE_TYPES.Tracks:
      StatComponent = TrackStats;
      break;
    default:
      break;
  }

  return (
    <div className={styles.container}>
      <Panel divider>
        <div className={styles.statsContainer}>
          <StatComponent
            feature={props.feature}
            hideCoords={props.hideCoords}
          />
        </div>
      </Panel>
    </div>
  );
}

FeatureStatistics.propTypes = {
  feature: PropTypes.object,
  hideCoords: PropTypes.bool,
};
